import { combineReducers } from "redux";
import userReducer from "../userData";
export const rootReducer = combineReducers({
  user: userReducer,
});
